<template>
  <div>
    <v-dialog v-model="shower" scrollable width="900px" persistent>
      <v-card class="rounded-lg">
        <v-card-title>
          <div v-if="announce">{{ $t("NewUpdate.announ3") }}</div>
          <div v-else>{{ $t("onechat.consentlist") }}</div>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="error"
            style="float: right"
            @click="Fn_Close()"
          >
            {{ $t("consentform.close") }}</v-btn
          >
        </v-card-title>
        <v-card-actions class="pa-2">
          <v-layout row wrap justify-start align-center pl-5>
            <v-flex xs2 lg2 ma-2>
              <v-select
                v-model="ItemPerPage"
                dense
                outlined
                hide-details
                rounded
                color="#077893"
                :items="ListPerpage"
                class="text-subtitle-2"
                prepend-icon="mdi-clipboard-list"
                append-icon="mdi-arrow-up-down"
                @input="Fn_SelectPerPage()"
              />
            </v-flex>

            <v-flex xs4 lg4 ma-2 pt-6>
              <v-text-field
                color="#077893"
                rounded
                outlined
                dense
                v-model="Search"
                :label="$t('consentlist.search')"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs2 lg2 ma-2 mr-9>
              <v-btn
                block
                dark
                rounded
                color="#077893"
                @click="Fn_confirm(SelectNameEmployee)"
                :loading="loadingConfirm"
                >{{ $t("email.text7") }}</v-btn
              >
            </v-flex>
          </v-layout>
        </v-card-actions>
        <v-card-text class="pt-4">
          <v-card outlined>
            <v-data-table
              :loading="btnSendLoading"
              v-model="SelectNameEmployee"
              :headers="headers"
              :items="ItemsAllEmployee"
              item-key="AccountId"
              :search="Search"
              show-select
              :items-per-page="ItemPerPage"
              :loading-text="$t('overlay.load')"
              hide-default-footer
            >
              <template v-slot:[`item.NameTh`]="{ item }">
                {{ item.TitleNameTh }} {{ item.NameTh }}
              </template>
              <template v-slot:[`item.NameEng`]="{ item }">
                {{ item.TitleNameEng }} {{ item.NameEng }}
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
        <v-card-actions style="justify-content: center" class="pb-3">
          <v-pagination
            total-visible="10"
            class="pt-2 pb-2"
            circle
            color="#077893"
            v-model="Page"
            :length="PageCount"
            @input="Fn_ChangePage"
          >
          </v-pagination>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DialogCheckUser
      :show="DialogList"
      :_detail="ItemsCheckUser"
      :_payload="payloadUserOnechat"
      @closeDialogDelete="DialogList = false"
    />
  </div>
</template>
<script>
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";
import DialogCheckUser from "./DialogConsentCheckUserOnechat.vue";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: {
    DialogCheckUser,
  },
  props: ["show", "_detail", "editName", "announce"],
  data: function () {
    return {
      Page: 1,
      PageCount: 0,
      ItemPerPage: 10,
      ListPerpage: [10, 50, 100],
      Total: 0,
      PayloadSearch: [],
      btnSendLoading: false,
      loadingConfirm: false,
      DialogList: false,
      ItemsAllEmployee: [],
      SelectNameEmployee: [],
      SelectConsentGroup: "",
      SelectConsentGeneral: "",
      ItemsCheckUser: [],
      payloadUserOnechat: {},
      Search: "",
    };
  },
  created() {},
  computed: {
    ...mapGetters(["DataGroupConsent"]),
    ...mapGetters(["DataGroupOneChatSearch"]),
    shower: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
    _profile: {
      get() {
        return this.$store.getters.profile;
      },
    },
    _apiKey: {
      get() {
        return this.$store.getters.apikey;
      },
    },
    _accesskey: {
      get() {
        return this.$store.getters.accessKey;
      },
    },
    _DataGroupOneChatSearch: {
      get() {
        return this.DataGroupOneChatSearch || "-";
      },
    },
    headers: {
      get() {
        return [
          {
            text: this.$i18n.t("dashboard.num"),
            value: "no",
            sortable: false,
          },
          {
            text: this.$i18n.t("onechat.nameTh"),
            value: "NameTh",
            sortable: false,
          },
          {
            text: this.$i18n.t("onechat.nameEng"),
            value: "NameEng",
            sortable: false,
          },
        ];
      },
    },
  },
  watch: {
    show(val) {
      if (val === true) {
        this.Page = 1;
        this.PageCount = 0;
        this.ItemPerPage = 10;
        this.ItemsAllEmployee = [];
        if (this.editName.length > 0) {
          this.SelectNameEmployee = this.editName;
        } else {
          this.SelectNameEmployee = [];
        }
        this.Fn_GetAllEmployee();
      }
    },
  },
  mounted() {},
  methods: {
    Fn_confirm(val) {
      if (this._DataGroupOneChatSearch.Consent === undefined) {
        this.$emit("closeDialog");
        this.$emit("confirmEmployee", val);
      } else if (this._DataGroupOneChatSearch.Consent.length > 0) {
        this.Fn_CheckUserOnechat();
      }
    },
    async Fn_CheckUserOnechat() {
      for (var i in this.SelectNameEmployee) {
        delete this.SelectNameEmployee[i].Email;
        delete this.SelectNameEmployee[i].Mobile;
      }
      if (this._DataGroupOneChatSearch.Type === "General") {
        this.SelectConsentGeneral =
          this._DataGroupOneChatSearch.Detail.Consent[0].ConsentId;
        this.SelectConsentGroup = "";
      } else if (this._DataGroupOneChatSearch.Type === "Group") {
        this.SelectConsentGeneral = "";
        this.SelectConsentGroup =
          this._DataGroupOneChatSearch.Detail.Consent[0].GroupId;
      }
      this.payloadUserOnechat = {
        UserName: this.$cookies.get("OneUsername"),
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        Receiver: this.SelectNameEmployee,
        ConsentGroupId: this.SelectConsentGroup,
        Consent: this.SelectConsentGeneral,
        PolicyId: this._DataGroupOneChatSearch.Detail.Policy[0].PolicyId,
        UserId: this.$cookies.get("OneAccountId"),
        GroupSend: this._DataGroupOneChatSearch.Detail.GroupSend,
        ShowPolicy: true,
      };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "onechat/CheckUserOneChatConsent",
          this.payloadUserOnechat
        )
        .then((response) => {
          this.LoadingSentConsent = false;
          if (response.data.Status === "OK") {
            this.ItemsCheckUser = response.data.Message;
            this.DialogList = true;
            this.$emit("closeDialog");
            this.$store.dispatch("SET_DATA_CHECK_USER", this.ItemsCheckUser);
          } else {
            this.LoadingSentConsent = false;
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.LoadingSentConsent = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_Close() {
      this.$emit("closeDialog");
    },
    async Fn_GetAllEmployee() {
      this.btnSendLoading = true;
      this.Page = 1;
      this.PayloadSearch = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccessToken: this.$cookies.get("OneAccessToken"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
        PerPage: this.ItemPerPage,
        Page: this.Page,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(this.PayloadSearch);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "business/employee/all",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.btnSendLoading = false;
          if (response.data.Status === "OK") {
            this.ItemsAllEmployee = response.data.Message.Employee;
            this.PageCount = response.data.Message.PageDetail.LastPage;
            this.Page = response.data.Message.PageDetail.CurrentPage;
            this.Total = response.data.Message.PageDetail.Total;

            var CountPage = response.data.Message.PageDetail.From;
            // Remove Value in ListPerpage
            // if (this.Total < 10) {
            //   this.ListPerpage = 10;
            // } else {
            //   var filteredArray = this.ListPerpage.filter(
            //     (e) => e < this.Total
            //   );
            //   this.ListPerpage = filteredArray;
            // }
            // /// // ฟังค์ชันสำหรับ เพิ่มลำดับลงในข้อมูล /////

            var startPage = CountPage;
            var nextPage = startPage + this.ItemsAllEmployee.length;
            var number = [];
            for (var i = startPage; i < nextPage; i++) {
              number.push(i);
            }
            for (var j in this.ItemsAllEmployee) {
              this.ItemsAllEmployee[j].no = number[j];
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.LoadingPosition = false;

          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
      // } else {
      //   Toast.fire({
      //     icon: "warning",
      //     title: "กรุณาเลือกรูปแบบการส่ง",
      //   });
      // }
    },
    async Fn_ChangePage() {
      this.btnSendLoading = true;
      var CountPage = this.Page++;
      this.PayloadSearch.Page = CountPage;
      this.PayloadSearch.PerPage = this.ItemPerPage;
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(this.PayloadSearch);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "business/employee/all",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.btnSendLoading = false;
          if (response.data.Status === "OK") {
            this.ItemsAllEmployee = response.data.Message.Employee;
            this.PageCount = response.data.Message.PageDetail.LastPage;
            this.Page = response.data.Message.PageDetail.CurrentPage;
            this.Total = response.data.Message.PageDetail.Total;

            var CountPage = response.data.Message.PageDetail.From;
            // Remove Value in ListPerpage
            // if (this.Total < 10) {
            //   this.ListPerpage = 10;
            // } else {
            //   var filteredArray = this.ListPerpage.filter(
            //     (e) => e < this.Total
            //   );
            //   this.ListPerpage = filteredArray;
            // }

            // /// // ฟังค์ชันสำหรับ เพิ่มลำดับลงในข้อมูล /////

            var startPage = CountPage;
            var nextPage = startPage + this.ItemsAllEmployee.length;
            var number = [];
            for (var i = startPage; i < nextPage; i++) {
              number.push(i);
            }
            for (var j in this.ItemsAllEmployee) {
              this.ItemsAllEmployee[j].no = number[j];
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.LoadingPosition = false;

          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
      // } else {
      //   Toast.fire({
      //     icon: "warning",
      //     title: "กรุณาเลือกรูปแบบการส่ง",
      //   });
      // }
    },
    async Fn_SelectPerPage() {
      this.btnSendLoading = true;
      this.Page = 1;
      var CountPage = this.Page++;
      this.PayloadSearch.Page = CountPage;
      this.PayloadSearch.PerPage = this.ItemPerPage;
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(this.PayloadSearch);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "business/employee/all",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.btnSendLoading = false;
          if (response.data.Status === "OK") {
            this.ItemsAllEmployee = response.data.Message.Employee;
            this.PageCount = response.data.Message.PageDetail.LastPage;
            this.Page = response.data.Message.PageDetail.CurrentPage;
            this.Total = response.data.Message.PageDetail.Total;

            var CountPage = response.data.Message.PageDetail.From;
            // Remove Value in ListPerpage
            // if (this.Total < 10) {
            //   this.ListPerpage = 10;
            // } else {
            //   var filteredArray = this.ListPerpage.filter(
            //     (e) => e < this.Total
            //   );
            //   this.ListPerpage = filteredArray;
            // }
            // /// // ฟังค์ชันสำหรับ เพิ่มลำดับลงในข้อมูล /////

            var startPage = CountPage;
            var nextPage = startPage + this.ItemsAllEmployee.length;
            var number = [];
            for (var i = startPage; i < nextPage; i++) {
              number.push(i);
            }
            for (var j in this.ItemsAllEmployee) {
              this.ItemsAllEmployee[j].no = number[j];
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.LoadingPosition = false;

          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
      // } else {
      //   Toast.fire({
      //     icon: "warning",
      //     title: "กรุณาเลือกรูปแบบการส่ง",
      //   });
      // }
    },
  },
};
</script>
<style scoped>
.noteStlye {
  width: 150px;
  word-wrap: break-word;
}
</style>
